import { MILLISECONDS } from '@/libs/core/src/lib/constants/time';
import type { TreatmentTypeUnion } from '@chiroup/core/types/Treatment.type';
import { use } from 'react';
import { useQuery } from 'react-query';
import { CustomizationListItem } from '../components/clinical-skills/CustomizationListItem.type';
import { MeContext } from '../contexts/me.context';
import { useSandboxClinicalData } from '../contexts/sandboxClinicalData.context';
import treatmentService from '../services/treatment.service';

type Props = {
  type: TreatmentTypeUnion;
  hide?: boolean;
  refetchOnMount?: boolean;
  categories?: string[];
};

const useTreatments = ({ type, hide = true, refetchOnMount = true, categories }: Props) => {
  const sandbox = useSandboxClinicalData();
  const { me } = use(MeContext);
  const { data, isFetching } = useQuery<{
    data: CustomizationListItem[];
  }>(
    `treatment-${type}`,
    key =>
      sandbox
        ? { data: [] }
        : treatmentService.list(me?.selectedClinic?.ID ?? -1, {
            hide,
            type,
            categories,
          }),
    {
      refetchOnWindowFocus: false,
      refetchOnMount,
      staleTime: MILLISECONDS.inHours(1),
    }
  );

  return { isFetching, data };
};

export default useTreatments;
